module.exports = __webpack_public_path__ + "media/assets_v3/images/ko-item-default-7aa58b27eb2a05e073eaf5cb9c355179.png";